export class KeyValueType {

    constructor(key: any = null, value: any = null) {
        this.key = key;
        this.value = value;
    }

    key: any;
    value: any;
};